interface LoadingDotsProps {
	color?: string;
	size?: "small" | "medium" | "large";
}

const SIZE_CLASSES = {
	small: "w-2 h-2",
	medium: "w-4 h-4",
	large: "w-6 h-6",
} as const;

export default function LoadingDots({ color, size = "medium" }: LoadingDotsProps) {
	const sizeClass = SIZE_CLASSES[size];

	return (
		<div
			className="spinner"
			role="status"
			aria-label="Loading"
		>
			<div
				className={`bounce1 ${sizeClass}`}
				style={{ backgroundColor: color }}
			/>
			<div
				className={`bounce2 ${sizeClass}`}
				style={{ backgroundColor: color }}
			/>
			<div
				className={`bounce3 ${sizeClass}`}
				style={{ backgroundColor: color }}
			/>
			<span className="sr-only">Loading...</span>
		</div>
	);
}
